import { render, staticRenderFns } from "./DashboardReceipt.vue?vue&type=template&id=af41495e"
import script from "./DashboardReceipt.vue?vue&type=script&lang=js"
export * from "./DashboardReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports